/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react'
import { useRoot } from 'Hooks'
import { Menu } from 'antd'
import { CloudOutlined, LineChartOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation, useParams } from 'react-router-dom'
import { Wrapper, SidebarFooter } from './styled'
import { COLLAPSE_MENU_ICON, DASHBOARD_ICON, WEEKLY_MANAGEMENT_ICON } from '../../Assets'

const { SubMenu } = Menu

export const getMenu = (t, id) => [
  {
    key: 'dashboard',
    label: t('dashboard'),
    icon: <DASHBOARD_ICON />,
    to: id ? `/dashboard/${id}` : '/dashboard'
  },
  {
    key: 'weekly_management',
    label: t('weekly_management'),
    icon: <WEEKLY_MANAGEMENT_ICON />,
    to: id ? `/weekly/${id}` : '/weekly'
  }
]

const HITSERIES_SUB_KEY = 'hitseries_cloud'
const LEARNING_SUB_KEY = 'gav_learning_data'

function useNavigationPageCount() {
  const { pathname } = useLocation()
  const [totalPages, setTotalPages] = useState(1)
  const prevPath = useRef(null)

  useEffect(() => {
    if (prevPath.current === null) {
      prevPath.current = pathname
      return
    }
    if (prevPath.current !== pathname) {
      prevPath.current = pathname
      setTotalPages((n) => n + 1)
    }
  }, [pathname])

  return totalPages
}

const SideBar = () => {
  const { sidebarCompact, sidebarHover, toggleSidebarAction } = useRoot()
  const { t } = useTranslation('menu')
  const { id } = useParams()
  const location = useLocation()
  const totalPages = useNavigationPageCount()
  const buildLabel = import.meta.env.VITE_BUILD_LABEL || 'vᵢ0.0.0-dev'

  const selectedKey = (() => {
    if (location.pathname.startsWith('/learning-data')) return 'learning_data'
    if (location.pathname.includes('/weekly')) return 'weekly_management'
    return 'dashboard'
  })()

  function handleToggleSidebar() {
    toggleSidebarAction()
  }

  const items = getMenu(t, id)

  return (
    <Wrapper
      sidebarCompact={sidebarCompact}
      sidebarHover={sidebarHover}
    >
      <div className="sidebar-menu-wrap">
        <Menu
          mode="inline"
          theme="light"
          selectedKeys={[selectedKey]}
          defaultOpenKeys={[HITSERIES_SUB_KEY, LEARNING_SUB_KEY]}
          className="gav-sidebar-menu"
        >
          <SubMenu
            key={HITSERIES_SUB_KEY}
            icon={<CloudOutlined />}
            title="HITSERIES CLOUD"
          >
            {items.map((item) => (
              <Menu.Item key={item.key} icon={item.icon}>
                <NavLink
                  onClick={() => handleToggleSidebar()}
                  activeClassName="menu-active"
                  to={item.to}
                >
                  {item.label}
                </NavLink>
              </Menu.Item>
            ))}
          </SubMenu>
          <SubMenu
            key={LEARNING_SUB_KEY}
            icon={<LineChartOutlined />}
            title={t('learning_data_menu')}
          >
            <Menu.Item key="learning_data">
              <NavLink
                onClick={() => handleToggleSidebar()}
                activeClassName="menu-active"
                to="/learning-data"
              >
                {t('learning_data_overview')}
              </NavLink>
            </Menu.Item>
          </SubMenu>
        </Menu>
      </div>

      <SidebarFooter className="sidebar-footer">
        <div className="sidebar-footer-line">
          Total:
          {' '}
          <strong>{totalPages}</strong>
          {' '}
          pages
        </div>
        <div className="sidebar-footer-line">© TANAAKK</div>
        <div className="sidebar-footer-version" title={buildLabel}>
          {buildLabel}
        </div>
      </SidebarFooter>

      <button type="button" className="collapse" onClick={handleToggleSidebar}>
        <COLLAPSE_MENU_ICON />
      </button>
    </Wrapper>
  )
}

export default SideBar
